import { createSlice } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';

export const COMMUNICATION_EMAIL_LIMIT = 200;

// Initial state
const initialState = {
  selectedEmailsIds: [],
  selectedMailboxId: '',
  isGroupView: 'false',
};
// Actual Slice
export const communicationSlice = createSlice({
  name: 'communication',
  initialState,
  reducers: {
    setSelectedEmailIds: (state, { payload }) => {
      state.selectedEmailsIds = payload.ids;
    },
    setCommunicationView: (state, { payload }) => {
      if (!state) {
        state = { ...initialState, isGroupView: payload.grouping };
      } else {
        state.isGroupView = payload.grouping;
      }
    },
    setCommunicationMailBoxId: (state, { payload }) => {
      if (!state) {
        state = { ...initialState, selectedMailboxId: payload.mailboxId };
      } else {
        state.selectedMailboxId = payload.mailboxId;
      }
    },

    // Special reducer for hydrating the state. Special case for next-redux-wrapper
    extraReducers: {
      [HYDRATE]: (state, action) => {
        return {
          ...state,
          ...action.payload.errors,
        };
      },
    },
  },
});

export const {
  setSelectedEmailIds,
  setCommunicationView,
  setCommunicationMailBoxId,
} = communicationSlice.actions;

export const selectCommunicationState = (state) => state.communication || {};

export const changeSelectedEMailIds = (ids) => {
  return (dispatch) => {
    dispatch(setSelectedEmailIds({ ids }));
  };
};

export const changeCommunicationView = ({ grouping }) => {
  return (dispatch) => {
    dispatch(setCommunicationView({ grouping }));
  };
};

export const changeCommunicationMailBoxId = ({ mailboxId }) => {
  return async (dispatch) => {
    dispatch(setCommunicationMailBoxId({ mailboxId }));
  };
};

export default communicationSlice.reducer;
